import { nanoid, customAlphabet } from 'nanoid'

export const generateNanoId = (limit = 7, alphabet) => {
  if (alphabet) {
    return customAlphabet(alphabet, limit)()
  }
  return nanoid(limit)
}
